import { create } from 'zustand';

type KeyboardStore = {
  isKeyboardOpen: boolean;
  setKeyboardOpen: (isOpen: boolean) => void;
};

const getKeyboardStoreDefaultValue = (): OmitFunctions<KeyboardStore> => ({
  isKeyboardOpen: false,
});

export const useKeyboardStore = create<KeyboardStore>((set) => ({
  ...getKeyboardStoreDefaultValue(),
  setKeyboardOpen: (isOpen) => set({ isKeyboardOpen: isOpen }),
}));
